import EmptyState from "../store/emptyState";
import { OverlayActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const { SHOW, HIDE } = OverlayActionConstants;

const overlay = (state = EmptyState.overlay, action) => {
  if (!state) return {};

  const { type, payload } = action;

  switch (action.type) {
    case SHOW: {
      return Object.assign({}, state, {
        overlays: [
          ...state.overlays.filter(
            x => x.identifier !== payload.options.identifier
          ),
          payload.options
        ]
      });
    }
    case HIDE:
      return Object.assign({}, state, {
        overlays: state.overlays.filter(
          x => x.identifier !== payload.options.identifier
        )
      });

    default:
      return globalReducerHelper(
        state,
        type,
        (payload && payload.overlay) || {},
        EmptyState.overlay
      );
  }
};

export default overlay;
